import { Box } from "@mui/system";

export default function NotFound() {
  return (
    <Box sx={{ p: 3 }}>
      <h1>
        Page not found
        <span role="img" aria-label="Face With Rolling Eyes Emoji">
          🤔
        </span>
      </h1>
    </Box>
  )
}